import React from 'react'
import { Icon } from '@iconify/react'
import styles from './suggestive-message.module.scss'

interface SuggestiveMessageProps {
  title: string
  subtitle: string
  icon?: string
}

export const SuggestiveMessage: React.FC<SuggestiveMessageProps> = ({
  title,
  subtitle,
  icon = 'mdi:account-search-outline',
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.iconWrapper}>
          <Icon icon={icon} width={48} height={48} />
        </div>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.subtitle}>{subtitle}</p>
      </div>
    </div>
  )
}
